import { setContext } from "svelte";
import { UserProcessNavigator } from "./modules/UserProcessNavigator";
import { DefaultApiService, MockApiService } from "./services";
import { Configuration } from "./services/assesment";
import { AppSettings } from "./AppSettings";
export function registerDependencies() {
    const urlParams = new URLSearchParams(window.location.search);
    const isBasic = urlParams.has('basic');

    setContext('mode-override', (isBasic) ? 'basic' : 'full');
 
    setContext('api-service', (AppSettings.MOCK)?new MockApiService : new DefaultApiService()); 

    setContext('navigator', new UserProcessNavigator());
}